module.exports = __webpack_public_path__ + "static/media/login-mobile.b5418d42.png";